// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

function isGunAvailable() {
  return Stdlib_Option.isSome(Primitive_option.fromNullable(window.Gun));
}

export {
  isGunAvailable,
}
/* No side effect */
